var parameterInsert={  
    IdEnterprise:'',
    BaseIdDocListSelect:'0',
    Name:'',  
    Active:'1',
    User:'',
    IP:'',
    BaseType:0,
    IsActiveEmail:2
} 
var parameterUpdate={ 
    IdDocListSelect:'', 
    Name:'',  
    Active:'1',
    User:'',
    IP:'',
    IsActiveEmail:2
} 
var parameterView={ 
    IdEnterprise:'',
    Name:'',  
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}